import { Button, Stack, Tab, Tabs, Typography } from '@mui/material'
import { Box, Container } from '@mui/system'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import JobList from './JobList'
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react';
import useAuth from '../../hooks/use-auth'
import { ROLE } from '../../constants'
import JobDraft from './JobDraft'
import useAxiosPrivate from '../../hooks/use-axios-private'
import { useEffect } from 'react'
import Badge from '@mui/material/Badge';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 4 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const JobsHome = () => {
    const theme = useTheme()
    const navigate = useNavigate()
    const [value, setValue] = useState(1);
    const { protector } = useAuth()
    const axios = useAxiosPrivate()
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [jobCount, setJobCount] = useState(false)
    async function getDashboardMetrics() {
        try {
            const response = await axios.get("dashboard/")
            console.log("🚀 ~ file: Homepage.jsx:17 ~ getDashboardMetrics ~ response:", response)
            setJobCount(response.data.data.jobs_count)

        }
        catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        getDashboardMetrics()
    }, [])
    return (
        <Container maxWidth="xl">
            <Box flex={5}>
                <Stack sx={{ mb: 2, mt: 3 }} direction='row' justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Jobs </Typography>
                    </Box>
                    {protector([ROLE.client]) && <Box>
                        <Button variant="contained" onClick={() => navigate('/jobs/create')} >Create Job</Button>
                    </Box>}
                </Stack>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            {protector([ROLE.client]) &&
                                <Tab label={<Box sx={{ display: "flex", alignItems: "center" }}>
                                    Drafts
                                    <Badge badgeContent={jobCount.drafts} color="primary" className='cs-badge' sx={{ ml: 2, }}></Badge>
                                </Box>} value={0} />
                            }
                            <Tab label="Orders" value={1} />
                            <Tab label="In Progress" value={2} />
                            <Tab label="Completed" value={3} />
                           
                        </Tabs>
                    </Box>
                    {protector([ROLE.client]) &&
                        <TabPanel value={value} index={0}>
                            <JobDraft onChange={getDashboardMetrics} />
                        </TabPanel>
                    }

                    <TabPanel value={value} index={1}>
                        <JobList jobstatus={0} onChange={getDashboardMetrics} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <JobList jobstatus={2} onChange={getDashboardMetrics} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <JobList jobstatus={3} onChange={getDashboardMetrics} />
                    </TabPanel>

                </Box>
            </Box>
        </Container>
    )
}

export default JobsHome